import React from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import { startApp } from './actions/startApp';
import ScheduleClient from './components/ScheduleClient';
import { store, syncClient } from './store';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken()).then((user) => {
  if (user) {
    store.dispatch(startApp());
    initializeSynchronization();
  }
});

function initializeSynchronization() {
  syncClient.whenReady.then(() => {
    syncClient.state.store = store;
  });
}

const root = createRoot(document.querySelector('.root')!);
root.render(<ScheduleClient reduxStore={store} />);
